import Icon from '../../assets'

const TitleCell = () => {
  return ({ title, urls }) => {
    const { control, destination } = urls

    return (
      <div className='articles-overview__table-title'>
        <a href={window.location.origin + control} class='qa-title-link'>{title}</a>
        {destination &&
        <a className='articles-overview__destination-icon qa-destination-link' href={destination} target='_blank'>
          <Icon icon='externalLink' width={16} height={16} />
        </a>
        }
      </div>
    )
  }
}

export default TitleCell
